import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const UnknownError = BaseErrorSchema.extend({
  errorType: z.literal('UnknownError'),
  errorReason: z.string(),
});

export type UnknownError = z.infer<typeof UnknownError>;

export const isUnknownError = (
  error: Record<string, unknown>,
): error is UnknownError => {
  return (
    error.errorType === 'UnknownError' && typeof error.errorReason === 'string'
  );
};

export const createUnknownError = (reason: string): UnknownError => ({
  errorType: 'UnknownError',
  errorReason: reason,
});
